import { ToolOrderStatus } from '@bechtel/ht-types';

export enum OrderStatusType {
  Open = 'Open',
  Prepared = 'Prepared',
  OutofStock = 'OutofStock',
  Cancelled = 'Cancelled',
  Completed = 'Completed',
}
export enum ToolOrderCatalogViewStatus {
  All = 'All',
  Pick = 'Pick',
  PickAlt = 'Pick Alt',
  Ready = 'Ready',
  Picked = 'Picked',
  Not_Picked = 'Not Picked',
  Cancelled = 'Cancelled',
  OutOfStock = 'OOS',
  Prepared = 'Prepared',
  Partial = 'Partial',
  Undo = 'Undo',
  Deleted = 'Deleted',
}
export interface OrderStatusTabProps {
  id: number;
  name: string;
  type: OrderStatusType;
  active: boolean;
  isPinnable: boolean;
  pinned?: boolean;
  count?: number;
  onSelect?: () => void;
  statsIndicator: boolean;
}

export const displayErrorMessage = (message: string) => {
  let displayMessage = 'Error occured, While procesing your request';
  if (message) {
    displayMessage = message.replace(/_/g, ' ').toUpperCase();
  }
  return displayMessage;
};

export const getToolOrderStatus = (status: OrderStatusType): ToolOrderStatus[] => {
  switch (status) {
    case OrderStatusType.Open:
      return [ToolOrderStatus.PLACED, ToolOrderStatus.IN_PROGRESS];
    case OrderStatusType.Cancelled:
      return [ToolOrderStatus.CANCELLED];
    case OrderStatusType.Completed:
      return [ToolOrderStatus.COMPLETED];
    case OrderStatusType.OutofStock:
      return [ToolOrderStatus.OUTOFSTOCK];
    case OrderStatusType.Prepared:
      return [ToolOrderStatus.PREPARED];
    default:
      return [];
  }
};
export const orderStatusTabs: OrderStatusTabProps[] = [
  {
    id: 1,
    name: 'Open',
    type: OrderStatusType.Open,
    active: true,
    isPinnable: true,
    count: 10,
    statsIndicator: false,
  },
  {
    id: 2,
    name: 'Prepared',
    type: OrderStatusType.Prepared,
    active: true,
    isPinnable: true,
    count: 10,
    statsIndicator: false,
  },

  {
    id: 3,
    name: 'Out of Stock',
    type: OrderStatusType.OutofStock,
    active: false,
    isPinnable: true,
    statsIndicator: false,
  },
  {
    id: 4,
    name: 'Completed',
    type: OrderStatusType.Completed,
    active: false,
    isPinnable: false,
    statsIndicator: false,
  },
  {
    id: 5,
    name: 'Cancelled',
    type: OrderStatusType.Cancelled,
    active: false,
    isPinnable: false,
    statsIndicator: false,
  },
];
export const getStatusColor = (status: any) => {
  if (!status) {
    return 'blue.400';
  }
  switch (status.toUpperCase()) {
    case 'OUTOFSTOCK':
    case 'OOS':
      return 'orange.500';
    case 'COMPLETED':
      return 'green.500';
    case 'PICKED':
      return 'green.400';
    case 'CANCELLED':
      return 'red.200';
    case 'READY':
      return 'blue.500';
    case 'PICK':
    case 'PICK ALT':
      return 'grey.300';
    case 'IN_PROGRESS':
      return 'blue.300';
    case 'OPEN':
    case 'PLACED':
      return 'grey.300';
    case 'PREPARED':
    default:
      return 'blue.500';
  }
};
